import * as React from 'react';
import Layout from '../Layout/Layout';

export default function Assessments() {
  return (
    <Layout pageTitle="Assessments">
    </Layout>
  );
}
